import { Table, TableBody, TableRow, TableCell, Avatar, Typography, Box } from "@mui/material"
import { AuditTrailReadModel } from '../GeneratedClients/FreeBillApi'
import { DateField, ReferenceField, TextField, useTranslate } from "react-admin"
import { useNavigate } from 'react-router-dom'
import firstLetterToLowerCase from "../helpers/firstLetterToLowerCase"
import MapEventToIcon from "../auditTrails/MapEventToIcon"

const AuditTrailsTable = ({auditTrails, totalAuditTrails}: {auditTrails: AuditTrailReadModel[], totalAuditTrails: number}) => {
  
  const translate = useTranslate()
  const navigate = useNavigate()
  const handleRowClick = (id?: string | null) => {
    navigate({
      pathname: `/invoices/${id}/show`,
    })
  }
  
  return (
    <Table size="small" sx={{mt:2}}>
      <TableBody>
        <TableRow>
          <TableCell>Datum</TableCell>
          <TableCell>Aktivität</TableCell>
          <TableCell>Rechnung</TableCell>
          <TableCell>Empfänger</TableCell>
        </TableRow>
        {
          auditTrails.map((auditTrail, i) =>
            i < totalAuditTrails &&
            <TableRow hover onClick={() => handleRowClick(auditTrail.eventId)} sx={{cursor: "pointer"}} key={i}>
              <TableCell><DateField record={auditTrail} source="eventOccuredAt" showTime /></TableCell>
              <TableCell>
                <Box display={"flex"} alignItems={"center"}>
                  <Avatar sx={{width: 25, height: 25}}>{MapEventToIcon(auditTrail.eventName, "small")}</Avatar>
                  <Typography ml={1} variant="body2">{translate(`resources.auditTrail.${firstLetterToLowerCase(auditTrail.eventName)}`)}</Typography>
                </Box>
              </TableCell>
              <TableCell>
                <ReferenceField record={auditTrail} reference="invoices" source="eventId" link={false} >
                  <TextField source="invoiceNumber" />
                </ReferenceField>
              </TableCell>
              <TableCell>
                <ReferenceField record={auditTrail} reference="invoices" source="eventId" link={false} >
                  <TextField source="invoiceRecipient.company.companyName" />
                </ReferenceField>
              </TableCell>
            </TableRow>
          )
        }
      </TableBody>
    </Table>
  )
}

export default AuditTrailsTable